import { convertValuesToFormData } from '../../components/react-hook-form/utils/convert-values';
import { DateNightFormData } from '../../screens/DateNight/components/DateNightForm';
import { EndPointService } from '../api-handlers/axios';

const ROUTE = 'date-nights';

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: string) => EndPointService.get(`/${ROUTE}/${id}`);
const create = (data: DateNightFormData) => {
    const formData =
        convertValuesToFormData({
            name: data.name,
            description: data.description,
            materialsSuppliesNeeded: data.materialsSuppliesNeeded,
            additionalInstructions: data.additionalInstructions,
            priceType: data.priceType,
            imageFile: data.imageFile[0],
        }) || {};

    return EndPointService.post(`/${ROUTE}/`, formData);
};
const update = (id: string, data: any) => {
    const formData =
        convertValuesToFormData({
            name: data?.name,
            description: data?.description,
            materialsSuppliesNeeded: data?.materialsSuppliesNeeded,
            additionalInstructions: data?.additionalInstructions,
            priceType: data?.priceType,
            imageFile: data?.imageFile[0],
            previewFile: data?.previewFile[0],
        }) || {};

    return EndPointService.patch(`/${ROUTE}/${id}`, formData);
};
const remove = (id: string) => EndPointService.delete(`/${ROUTE}/${id}`);

export default {
    list,
    get,
    update,
    create,
    remove,
};
